import { getPath } from '@/router/common'
const baseUrl = {
  title: '到货确认',
  path: 'dhqr'
}

export default [
  {
    path: getPath('index', baseUrl),
    name: 'dhqr_index',
    component: () => import(/* webpackChunkName: "dhqr_index" */ '@/views/dhqr/index/index.vue'),
    meta: {
      title: '到货确认'
    }
  },
  {
    path: getPath('inventoryInTransit', baseUrl),
    name: 'dhqr_inventoryInTransit',
    component: () => import(/* webpackChunkName: "dhqr_inventoryInTransit" */ '@/views/dhqr/inventoryInTransit/index.vue'),
    meta: {
      title: '在途清单|到货清单'
    }
  },
  {
    path: getPath('CheckAbnormal', baseUrl),
    name: 'dhqr_CheckAbnormal',
    component: () => import(/* webpackChunkName: "dhqr_CheckAbnormal" */ '@/views/dhqr/checkAbnormal/index.vue'),
    meta: {
      title: '异常登记'
    }
  }
]
